/* Acierto - comportamientos sencillos (buscador de regalos, franja que se para al tocar) */
(function () {
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function initFinder(root) {
    if (root.__acf) return;
    root.__acf = true;
    var cards = qsa(root, '.acf__card');
    var count = root.querySelector('[data-count]');
    var empty = root.querySelector('[data-empty]');
    var moreBtn = root.querySelector('[data-more]');
    var moreN = root.querySelector('[data-more-n]');
    var initialLimit = parseInt(root.getAttribute('data-limit'), 10) || cards.length;
    var state = { who: 'todos', min: 0, max: 100000, limit: initialLimit };

    function apply() {
      var matches = [];
      cards.forEach(function (c) {
        var who = c.getAttribute('data-who') || '';
        var price = parseFloat(c.getAttribute('data-price'));
        var okWho = state.who === 'todos' || who.indexOf(',' + state.who + ',') !== -1;
        var okPrice = price >= state.min && price <= state.max;
        if (okWho && okPrice) matches.push(c);
      });
      cards.forEach(function (c) { c.hidden = true; });
      var visible = matches.slice(0, state.limit);
      visible.forEach(function (c) { c.hidden = false; });

      var total = matches.length;
      var shown = visible.length;
      if (count) {
        if (total === 0) { count.textContent = 'Mostrando 0 ideas'; }
        else if (shown < total) { count.textContent = 'Mostrando ' + shown + ' de ' + total + ' ideas'; }
        else { count.textContent = shown === 1 ? 'Mostrando 1 idea' : 'Mostrando ' + shown + ' ideas'; }
      }
      if (empty) empty.hidden = total !== 0;
      if (moreBtn) {
        var remaining = total - shown;
        moreBtn.hidden = remaining <= 0;
        if (moreN) moreN.textContent = remaining > 0 ? '(+' + remaining + ')' : '';
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.limit += initialLimit;
        apply();
      });
    }

    qsa(root, '[data-group="who"] .acf__chip').forEach(function (b) {
      b.addEventListener('click', function () {
        state.who = b.getAttribute('data-value');
        state.limit = initialLimit;
        qsa(root, '[data-group="who"] .acf__chip').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });
    qsa(root, '[data-group="budget"] .acf__chip').forEach(function (b) {
      b.addEventListener('click', function () {
        state.min = parseFloat(b.getAttribute('data-min'));
        state.max = parseFloat(b.getAttribute('data-max'));
        state.limit = initialLimit;
        qsa(root, '[data-group="budget"] .acf__chip').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });

    // enlaces tipo /pages/regalos?para=pareja
    try {
      var params = new URLSearchParams(window.location.search);
      var para = params.get('para');
      if (para) {
        var target = root.querySelector('[data-group="who"] .acf__chip[data-value="' + para + '"]');
        if (target) target.click();
      }
    } catch (e) { /* sin soporte */ }

    apply();
  }

  function initMarquee(root) {
    if (root.__acm) return;
    root.__acm = true;
    var track = root.querySelector('[data-track]');
    var first = root.querySelector('[data-set]');
    if (!track || !first) return;
    var setW = 0, x = 0, last = 0;
    var speed = 42;
    var dragging = false, startX = 0, startPos = 0, hover = false, holdUntil = 0;
    var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var host = root.closest('.shopify-section') || root.parentElement;

    function fit() {
      var w = host.getBoundingClientRect().width || document.documentElement.clientWidth;
      root.style.width = Math.floor(w) + 'px';
      return w;
    }
    function measure() {
      var vw = fit();
      setW = first.getBoundingClientRect().width;
      if (!setW) return;
      var need = Math.min(Math.ceil((vw * 2) / setW) + 1, 8);
      var have = track.children.length;
      for (var i = have; i < need; i++) {
        var c = first.cloneNode(true);
        c.removeAttribute('data-set');
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      }
    }
    function norm() {
      if (!setW) return;
      while (x <= -setW) { x += setW; startPos += setW; }
      while (x > 0) { x -= setW; startPos -= setW; }
    }
    function frame(t) {
      var dt = last ? Math.min((t - last) / 1000, 0.1) : 0;
      last = t;
      if (!dragging && !hover && !reduced && t > holdUntil) { x -= speed * dt; }
      norm();
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
      requestAnimationFrame(frame);
    }
    function down(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      startX = e.clientX;
      startPos = x;
      root.classList.add('is-dragging');
      if (root.setPointerCapture) { try { root.setPointerCapture(e.pointerId); } catch (err) {} }
    }
    function move(e) {
      if (!dragging) return;
      x = startPos + (e.clientX - startX);
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      holdUntil = performance.now() + 3000;
    }
    root.addEventListener('pointerdown', down);
    root.addEventListener('pointermove', move);
    root.addEventListener('pointerup', up);
    root.addEventListener('pointercancel', up);
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });
    measure();
    if (window.ResizeObserver) { new ResizeObserver(function () { measure(); }).observe(host); }
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    requestAnimationFrame(frame);
  }

  function initAll() {
    qsa(document, '[data-finder]').forEach(initFinder);
    qsa(document, '[data-marquee]').forEach(initMarquee);
  }
  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
